export default {
  cscName: 'CSC Name',
  reportType: 'Report Type',
  giDate: 'GI Date',
  orderType: 'Order Type',
  shipFrom: 'Ship From',
  shipTo: 'Ship To',
  byCarton: 'Carton/(by Carton)',
  byExp: 'Express Tracking Number/(by Exp)',
  byPiece: 'Piece/(by Piece)',
  cordCarton: 'CORD Carton Qty',
  cordCartonExp: 'EXP No. Qty',
  noScanQty: 'No Scan Qty',
  rfidScannedQty: 'RFID Scanned Qty',
  accurateQty: 'Accurate Qty',
  epcShortageQty: 'EPC Shortage Qty',
  epcOverageQty: 'EPC Overage Qty',
  upcMismatchQty: 'UPC Mismatch Qty',
  unexpectedQty: 'Unexpected Qty',
  byCartonAccuracy: 'By Carton Accuracy',
  cordEpcQty: 'CORD EPC Qty',
  noScanQtyPiece: 'No Scan Qty (Piece)',
  rfidScannedQtyPiece: 'RFID Scanned Qty (Piece)',
  accurateQtyPiece: 'Accurate Qty (Piece)',
  epcShortageGapQtyPiece: 'EPC Shortage Gap Qty (Piece)',
  epcOverageGapQtyPiece: 'EPC Overage Gap Qty (Piece)',
  upcMismatchQtyPiece: 'UPC Mismatch Qty (Piece)',
  unexpectedQtyPiece: 'Unexpected Qty (Piece)',
  byEpcAccuracy: 'By EPC Accuracy',
  tipTitle1: `Carton (by Carton) / EXP No. (by EXP No.)`,
  tip1: `CORD Carton/EXP No. Qty: CORD post至T-HUB的箱/单数量`,
  tip2: `No Scan Qty: CORD post至T-HUB但是未经过WMS扫描的箱/单数量`,
  tip3: `RFID Scanned Qty: WMS扫描的箱/单数量(去重)`,
  tip4: `Accurate Qty: CORD 箱/单内UPC件数与WMS箱/单内UPC件数完全相符箱/单数量`,
  tip5: `EPC Shortage Qty: 同一箱/单号，WMS箱/单内UPC件数少于CORD箱/单内UPC件数的箱/单数量`,
  tip6: `EPC Overage Qty: 同一箱/单号，WMS箱/单内UPC件数少多于CORD箱/单内UPC件数的箱/单数量`,
  tip7: `UPC Mismatch Qty: 同一箱/单号，WMS相较于CORD箱/单内混入额外UPC，或者存在A UPC少，B UPC多的情况的箱/单数量`,
  tip8: `Unexpected Qty: WMS扫描但是无CORD记录的箱/单数量`,
  tip9: `By Carton Accuracy: Accurate Qty / (CORD Carton/EXP No. Qty)`,
  tipTitle2: `Piece (by Piece)`,
  tipPiece1: `CORD EPC Qty: CORD post至T-HUB的产品箱/单内件数量`,
  tipPiece2: `No Scan Qty (Piece): CORD post至T-HUB但是未经过WMS扫描的箱/单内件数`,
  tipPiece3: `RFID Scanned Qty (Piece): WMS扫描的箱/单内件数(EPC去重)`,
  tipPiece4: `Accurate Qty (Piece): CORD 箱/单内UPC件数与WMS箱/单内UPC件数完全相符箱/单内件数`,
  tipPiece5: `EPC Shortage Gap Qty (Piece): 同一箱/单号，WMS箱/单内UPC件数少于CORD箱/单内UPC件数的箱/单, 统计Acutal Order Qty - RFID Scan Qty总差异件数`,
  tipPiece6: `EPC Overage Gap Qty (Piece): 同一箱/单号，WMS箱/单内UPC件数多于CORD箱/单内UPC件数的箱/单, 统计RFID Scan Qty - Acutal Order Qty 总差异件数`,
  tipPiece7: `UPC Mismatch Qty (Piece): 同一箱/单号，WMS相较于CORD箱/单内混入额外UPC，或者存在A UPC少，B UPC多的情况的箱/单内件数`,
  tipPiece8: `Unexpected Qty (Piece): WMS扫描但是无CORD记录的箱/单内扫描件数`,
  tipPiece9: `By EPC Accuracy: Accurate Qty / (CORD EPC Qty)`
}
